import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgProgress } from '@ngx-progressbar/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {
  isFooterDisable: boolean = true;
  title = 'app';
  options = {
    min: 8,
    max: 100,
    ease: 'linear',
    speed: 200,
    trickleSpeed: 300,
    meteor: true,
    spinner: true,
    spinnerPosition: 'right',
    direction: 'ltr+',
    color: 'red',
    thick: true
  };
  startedClass = false;
  completedClass = false;
  preventAbuse = false;

  constructor(
    private route: Router
  ) { }

  ngOnInit(): void {
    setTimeout(() => {
      if(this.route.navigated) {
        if(this.route.url === '/quote') { this.isFooterDisable = false; } else { this.isFooterDisable = true; }
      }
    });
  }

  onStarted() {
    this.startedClass = true;
    setTimeout(() => { this.startedClass = false; }, 800);
  }

  onCompleted() {
    this.completedClass = true;
    setTimeout(() => { this.completedClass = false; }, 800);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts